import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { DictionaryCode } from '../../../enums/dictionary-code';

@Component({
  selector: 'app-tachograph-cell',
  imports: [TranslatePipe],
  templateUrl: './make-and-model-cell.component.html',
  styleUrl: './make-and-model-cell.component.scss',
})
export class MakeAndModelCellComponent {
  public readonly make = input.required<string | null>();
  public readonly model = input.required<string | null>();
  public readonly makeDictionaryCode = input<DictionaryCode>();
  public readonly modelDictionaryCode = input<DictionaryCode>();
}
